import { ACTION_TYPE } from "./type";
import Config from "../../utilities/config";
import { store } from "../store";
import {
  fetchPriceRangeMinMax,
  getSEOData,
  productDescription,
  productfilterlistitem,
  productlistitems,
  productSizeList,
} from "../../utilities/api";
import config from "../../utilities/config";
import { formatCurrencywithamount } from "../../utilities/helper";
import constants from "../../utilities/constants";

export const product_description = (skuId) => async (dispatch) => {
  // dispatch({ type: ACTION_TYPE.GET_PRODUCT_DATA_REQUEST });
  try {
    const product_description_data = await productDescription(skuId);
    Config.logGeneral &&
      config.logGeneral && console.log(
        product_description_data,
        "product_description_data 77777777"
      );

    if (
      product_description_data?.data?.data?.allTransSkuLists?.nodes?.length > 0
    ) {
      dispatch({
        type: ACTION_TYPE.GET_PRODUCT_DATA_RESPONSE_SUCCESS, //GET_PRODUCT_DATA_RESPONSE_SUCCESS
        payload: {
          productResponseSuccess:
            product_description_data?.data?.data?.allTransSkuLists?.nodes,
        },
      });
    } else {
      dispatch({
        type: ACTION_TYPE.GET_PRODUCT_DATA_RESPONSE_FAILURE,
        errorMessage: "No data found!!",
      });
    }
  } catch (error) {
    Config.logGeneral &&
      config.logGeneral && console.log("Error productDescriptionResponseError", error);
    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
export const getProductSizeList = (skuSizes, productId) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_PRODUCT_SIZE_DATA_REQUEST });

  try {
    const sizeListResponse = await productSizeList(skuSizes, productId);

    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_SIZE_DATA_RESPONSE_SUCCESS,
      payload: {
        productSizeResponseSuccess: sizeListResponse,
      },
    });
  } catch (error) {
    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_SIZE_DATA_RESPONSE_FAILURE,
      errorMessage: error,
    });
  }
};

export const product_list_filter_category = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_SEARCH_CATEGORY_DATA_REQUEST });
  try {
    const product_list_filter_data = await productfilterlistitem();
    dispatch({
      type: ACTION_TYPE.GET_SEARCH_CATEGORY_DATA_RESPONSE_SUCCESS,
      payload: {
        searchcategoryResponseSuccess: product_list_filter_data?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: ACTION_TYPE.GET_SEARCH_CATEGORY_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};

// Filter request tracking
let activeFilterRequest = null;
let lastFilterParams = null;
let lastFilterTime = 0;

export const product_list_filter = (filtervalue) => async (dispatch) => {
  const requestKey = JSON.stringify(filtervalue);
  const now = Date.now();
  
  // Prevent duplicate calls within 1 second
  if (lastFilterParams === requestKey && 
      activeFilterRequest && 
      (now - lastFilterTime) < 1000) {
    return activeFilterRequest;
  }

  // Cancel previous request
  if (activeFilterRequest) {
    activeFilterRequest.cancelled = true;
  }

  dispatch({ type: ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_REQUEST });
  
  // Start with required defaults
  var filter = {
    material: 'Silver',
    category: 'Jewellery'
  };
  
  config.logGeneral && console.log('Raw filtervalue received:', filtervalue);
  
  if (Array.isArray(filtervalue)) {
    filtervalue?.forEach((element) => {
      config.logGeneral && console.log('Processing SEO element:', element);
      
      if (element.attributeName && element.attributeValue) {
        const attrName = element.attributeName;
        const attrValue = element.attributeValue;
        
        // Map SEO attributes to filter API keys
        switch (attrName) {
          case 'Product Type':
            filter.producttype = attrValue;
            break;
          case 'Material':
            filter.material = attrValue;
            break;
          case 'Category':
            filter.category = attrValue;
            break;
          case 'Collection':
            filter.collection = attrValue;
            break;
          case 'Theme':
            filter.theme = attrValue;
            break;
          case 'Occasion':
            filter.occasion = attrValue;
            break;
          case 'Style':
            filter.style = attrValue;
            break;
          case 'Finish':
            filter.finish = attrValue;
            break;
          default:
            // Convert other attributes to lowercase
            const apiKey = attrName.toLowerCase().replace(/\s+/g, '');
            filter[apiKey] = attrValue;
        }
      }
    });
  } else if (filtervalue && typeof filtervalue === 'object') {
    filter = { ...filter, ...filtervalue };
  }
  
  const requestPromise = (async () => {
    try {
      config.logGeneral && console.log('Final Filter API payload:', JSON.stringify(filter, null, 2));
      const product_list_filter_data = await productfilterlistitem(filter);
      
      if (requestPromise.cancelled) return;
      
      dispatch({
        type: ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_SUCCESS,
        payload: {
          productResponseSuccess: product_list_filter_data?.data,
        },
      });
    } catch (error) {
      if (!requestPromise.cancelled) {
        dispatch({
          type: ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_FAILURE,
          errorMessage: error?.response?.data?.message,
        });
      }
    } finally {
      if (activeFilterRequest === requestPromise) {
        activeFilterRequest = null;
        lastFilterParams = null;
      }
    }
  })();

  requestPromise.cancelled = false;
  activeFilterRequest = requestPromise;
  lastFilterParams = requestKey;
  lastFilterTime = now;
  
  return requestPromise;
};

// Request tracking for deduplication
let activeProductListRequest = null;
let lastProductListParams = null;
let lastProductListTime = 0;

export const product_list_item = (productfil, offSet = 0) => async (dispatch) => {
  const requestKey = JSON.stringify({ productfil, offSet });
  const now = Date.now();
  
  config.logGeneral && console.log('product_list_item called with:', { productfil, offSet, requestKey });
  
  // Prevent duplicate calls within 2 seconds
  if (lastProductListParams === requestKey && 
      activeProductListRequest && 
      (now - lastProductListTime) < 2000) {
    config.logGeneral && console.log('Blocking duplicate product_list_item call');
    return activeProductListRequest;
  }

  // Cancel previous request
  if (activeProductListRequest) {
    activeProductListRequest.cancelled = true;
  }

  dispatch({ type: ACTION_TYPE.GET_PRODUCT_LIST_DATA_REQUEST });
  
  const requestPromise = (async () => {
    try {
      const product_list_item_data = await productlistitems(productfil, offSet);
      
      if (requestPromise.cancelled) return;
      
      dispatch({
        type: ACTION_TYPE.GET_PRODUCT_LIST_DATA_SUCCESS,
        payload: {
          productListitemResponseSuccess: product_list_item_data?.data,
          productMinPrice: product_list_item_data?.data?.data?.minPrice || 0,
          productMaxPrice: product_list_item_data?.data?.data?.maxPrice || 200000,
          currentOffset: offSet,
        },
      });
    } catch (error) {
      if (!requestPromise.cancelled) {
        dispatch({
          type: ACTION_TYPE.GET_PRODUCT_LIST_DATA_FAILURE,
          errorMessage: error?.response?.data?.message,
        });
      }
    } finally {
      if (activeProductListRequest === requestPromise) {
        activeProductListRequest = null;
        lastProductListParams = null;
      }
    }
  })();

  requestPromise.cancelled = false;
  activeProductListRequest = requestPromise;
  lastProductListParams = requestKey;
  lastProductListTime = now;
  
  return requestPromise;
};
export const updateSelectedFilters = (category, value, finalPriceRange) => (dispatch) => {
  const isCategoryValid = category !== null;

  const isFinalPriceValid =
    Array.isArray(finalPriceRange) &&
    finalPriceRange.length === 2 &&
    finalPriceRange[0] !== null &&
    finalPriceRange[1] !== null;

  // If neither is valid — skip dispatch
  if (!isCategoryValid && !isFinalPriceValid) {
    config.logGeneral && console.log("Skipping dispatch — both category and finalPriceRange invalid");
    return;
  }

  config.logGeneral &&
    console.log("updateSelectedFilters Dispatching", category, "vc", value, "finalPriceRange", finalPriceRange);

  dispatch({
    type: ACTION_TYPE.UPDATE_SELECTED_FILTERS,
    payload: { category, value, finalPriceRange },
  });
};

export const resetSelectedFilters = () => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.RESET_SELECTED_FILTERS,
  });
};

export const setPaginationOffset = (offset, page) => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.SET_PAGINATION_OFFSET,
    payload: { offset, page },
  });
};

export const resetPagination = () => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.RESET_PAGINATION,
  });
};

export const updateCurrentPriceRange = (priceRange) => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.UPDATE_CURRENT_PRICE_RANGE,
    payload: priceRange,
  });
};


// Price range request tracking
let activePriceRangeRequest = null;
let lastPriceRangeParams = null;
let lastPriceRangeTime = 0;

export const getPriceRangeMinMax = (filterPayload) => async (dispatch) => {
  const requestKey = JSON.stringify(filterPayload);
  const now = Date.now();
  
  config.logGeneral && console.log('getPriceRangeMinMax called with:', filterPayload);
  
  // Prevent duplicate calls within 1 second
  if (lastPriceRangeParams === requestKey && 
      activePriceRangeRequest && 
      (now - lastPriceRangeTime) < 1000) {
    config.logGeneral && console.log('Blocking duplicate getPriceRangeMinMax call');
    return activePriceRangeRequest;
  }

  // Cancel previous request
  if (activePriceRangeRequest) {
    activePriceRangeRequest.cancelled = true;
  }

  const requestPromise = (async () => {
    try {
      const data = await fetchPriceRangeMinMax(filterPayload);
      
      if (requestPromise.cancelled) return;
      
      let minPrice = data.minPrice ?? 0;
      let maxPrice = data.maxPrice ?? 200000;

      // Keep same price for single product scenario
      // if (maxPrice <= minPrice) {
      //   maxPrice = minPrice + 2000;
      // }

      dispatch({
        type: ACTION_TYPE.UPDATE_PRODUCT_LIST_PRICE_RANGE_SUCCESS,
        payload: {
          productMinPrice: minPrice,
          productMaxPrice: maxPrice,
        },
      });
    } catch (error) {
      if (config.logGeneral && !requestPromise.cancelled) {
        console.log("Error fetching price range min max:", error);
      }
    } finally {
      if (activePriceRangeRequest === requestPromise) {
        activePriceRangeRequest = null;
        lastPriceRangeParams = null;
      }
    }
  })();

  requestPromise.cancelled = false;
  activePriceRangeRequest = requestPromise;
  lastPriceRangeParams = requestKey;
  lastPriceRangeTime = now;
  
  return requestPromise;
};

export const intProductListItem = () => async (dispatch) => {
  config.logGeneral && console.log("====>intProductListItem");

  dispatch({ type: ACTION_TYPE.GET_PRODUCT_LIST_DATA_REQUEST });
};
export const updateProductDescriptionSuccess = (updatedData) => ({
  type: ACTION_TYPE.UPDATE_PRODUCT_DESCRIPTION_SUCCESS,
  payload: updatedData,
});

export const updateProductListItemsSuccess = (updatedData) => ({
  type: ACTION_TYPE.UPDATE_PRODUCT_LIST_ITEMS_SUCCESS,
  payload: updatedData,
});

export const product_listing_loading = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_PRODUCT_LIST_DATA_LOADING_FALSE });
};

//Get the SEO Data for filters
export const fetchSEOData = (condition) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_SEO_DATA_REQUEST });

  try {
    const getSEODataList = await getSEOData(condition);
    Config.logGeneral &&
      config.logGeneral && console.log(getSEODataList, condition, "==>apigetSEOData");

    dispatch({
      type: ACTION_TYPE.GET_SEO_DATA_SUCCESS,
      payload: {
        getSEODataResponseSuccess: getSEODataList?.data,
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Error getSEOData", error);
    dispatch({
      type: ACTION_TYPE.GET_SEO_DATA_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};

// Reset function to clear all active requests
export const resetActiveRequests = () => {
  if (activeProductListRequest) {
    activeProductListRequest.cancelled = true;
    activeProductListRequest = null;
  }
  if (activeFilterRequest) {
    activeFilterRequest.cancelled = true;
    activeFilterRequest = null;
  }
  if (activePriceRangeRequest) {
    activePriceRangeRequest.cancelled = true;
    activePriceRangeRequest = null;
  }
  lastProductListParams = null;
  lastFilterParams = null;
  lastPriceRangeParams = null;
  lastProductListTime = 0;
  lastFilterTime = 0;
  lastPriceRangeTime = 0;
};
